import React, { useState, createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { checkRole } from "../utils/role";

export const TabSideBarContext = createContext({});

function TabSideBarProvider({ children }) {
  const [tabSidebar, setTabSidebar] = useState("P");
  const router = useHistory();
  const { user } = useSelector((state) => state.initializeApp);

  useEffect(() => {
    const tabSidebarLocal = localStorage.getItem("tabSidebar");
    if (tabSidebarLocal) {
      setTabSidebar(tabSidebarLocal);
    }
  }, [router.location.pathname]);

  return (
    <TabSideBarContext.Provider
      value={{
        tabSidebar,
        setTabSidebar,
      }}
    >
      {children}
    </TabSideBarContext.Provider>
  );
}

export default TabSideBarProvider;
